/* Carrusel del hero. Se carga solo desde sections/hero.liquid.
   Flechas, indicadores, autoplay con pausa al pasar el raton, swipe y teclado. */
(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (!track || slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var delay = (Number(root.getAttribute('data-hero-autoplay')) || 0) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var paused = false;


    // ---- Sangrado de fondo bajo el hero ----
    // Publica en --hero-blend el color de la fila que REALMENTE se ve abajo del
    // banner. No sirve la ultima fila del archivo: object-fit:cover recorta, y
    // en este tema llega a recortar 140px, asi que la fila visible es otra.
    var seccion = root.parentNode;
    while (seccion && seccion.className.indexOf('hero-c') === -1) seccion = seccion.parentNode;
    var colorCache = {};

    function fondoDelSlide(slide) {
      var inner = slide.querySelector('.hero-c__inner');
      return inner ? window.getComputedStyle(inner).backgroundColor : '';
    }

    // Traduce el recorte de object-fit:cover a FRACCIONES de la imagen (0..1).
    // En fracciones y no en pixeles a proposito: la copia que leemos del CDN
    // puede llegar a otra resolucion que la que esta pintando el navegador
    // (mismo archivo servido a 1440x480 y a 2000x667), y mezclar los dos
    // sistemas de coordenadas hace leer una fila equivocada.
    function zonaVisible(img) {
      var caja = img.getBoundingClientRect();
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh || !caja.width || !caja.height) return null;
      var escala = Math.max(caja.width / nw, caja.height / nh);
      var pos = (img.style.objectPosition || '').toLowerCase();
      var py = pos.indexOf('top') !== -1 ? 0 : (pos.indexOf('bottom') !== -1 ? 1 : 0.5);
      var sobraY = Math.max(0, nh * escala - caja.height);
      var sobraX = Math.max(0, nw * escala - caja.width);
      var fx = (sobraX / 2) / escala / nw;
      return {
        fy: Math.min(1, (sobraY * py + caja.height) / escala / nh),
        fh: Math.min(1, (caja.height / escala) / nh),
        fx: fx,
        fw: Math.min(1 - fx, (caja.width / escala) / nw)
      };
    }

    // Pasa esas fracciones a pixeles de la copia concreta que hemos descargado.
    // alto = que porcion del banner visible leer, contada desde abajo:
    //   0 -> solo la ultima fila (el borde, para empalmar sin costura)
    //   0.22 -> el ultimo 22% (la ZONA, de donde sale el color predominante)
    function recorte(g, m, alto) {
      var nw = m.naturalWidth, nh = m.naturalHeight;
      var sw = Math.max(1, Math.round(g.fw * nw));
      var sx = Math.max(0, Math.min(nw - sw, Math.round(g.fx * nw)));
      var abajo = Math.round(g.fy * nh);
      var sh = Math.max(1, Math.round((alto || 0) * g.fh * nh));
      var sy = Math.max(0, Math.min(nh - sh, abajo - sh));
      return { sx: sx, sy: sy, sw: sw, sh: sh };
    }

    // Mediana por canal sobre una fila de pixeles, con ventana ancha
    function medianaFila(d, ancho, radio) {
      var salida = new Uint8ClampedArray(ancho * 4);
      var ordenar = function (a, b) { return a - b; };
      for (var x = 0; x < ancho; x++) {
        for (var canal = 0; canal < 3; canal++) {
          var v = [];
          for (var j = Math.max(0, x - radio); j <= Math.min(ancho - 1, x + radio); j++) {
            v.push(d[j * 4 + canal]);
          }
          v.sort(ordenar);
          salida[x * 4 + canal] = v[v.length >> 1];
        }
        salida[x * 4 + 3] = 255;
      }
      return salida;
    }

    function luminancia(r, v, a) { return 0.2126 * r + 0.7152 * v + 0.0722 * a; }

    // Color del fondo de la pagina, hacia el que aclaramos
    function papel() {
      var c = window.getComputedStyle(document.documentElement).getPropertyValue('--paper').trim();
      var m = /^#([0-9a-f]{6})$/i.exec(c);
      if (m) {
        var n = parseInt(m[1], 16);
        return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
      }
      var r = /(\d+)\D+(\d+)\D+(\d+)/.exec(c);
      return r ? [+r[1], +r[2], +r[3]] : [250, 250, 247];
    }

    function aplicar(muestreo, slide) {
      // Solo si el banner sigue siendo el activo: la lectura es asincrona
      if (!muestreo || !seccion || slides[index] !== slide) return;
      if (muestreo.color) seccion.style.setProperty('--hero-blend', muestreo.color);
      // La tira reproduce el borde a lo ancho. Un color plano deja escalon cuando
      // el banner no acaba uniforme (p.ej. una pildora blanca centrada).
      if (muestreo.tira) seccion.style.setProperty('--hero-blend-img', 'url("' + muestreo.tira + '")');
      else seccion.style.removeProperty('--hero-blend-img');
    }

    function pintarSangrado() {
      if (!seccion) return;
      var slide = slides[index];
      var img = slide.querySelector('.hero-c__bg');
      var respaldo = fondoDelSlide(slide);
      if (!img || !img.currentSrc || !img.naturalWidth) { aplicar({ color: respaldo }, slide); return; }
      var g = zonaVisible(img);
      if (!g) { aplicar({ color: respaldo }, slide); return; }

      var clave = img.currentSrc + '|' + g.fy.toFixed(4) + '|' + g.fx.toFixed(4) + '|' + g.fw.toFixed(4);
      if (colorCache[clave]) { aplicar(colorCache[clave], slide); return; }

      var muestra = new Image();
      muestra.crossOrigin = 'anonymous';
      muestra.onload = function () {
        var res = { color: respaldo, tira: null };
        try {
          var ANCHO = 64, RADIO = 16, ALTO = 24;
          var lienzo = document.createElement('canvas');
          lienzo.width = ANCHO; lienzo.height = ALTO;
          var ctx = lienzo.getContext('2d', { willReadFrequently: true });

          // 1) BORDE: la ultima fila visible. Es la que empalma sin costura.
          var cb = recorte(g, muestra, 0);
          ctx.clearRect(0, 0, ANCHO, ALTO);
          ctx.drawImage(muestra, cb.sx, cb.sy, cb.sw, cb.sh, 0, 0, ANCHO, 1);
          var borde = medianaFila(ctx.getImageData(0, 0, ANCHO, 1).data, ANCHO, RADIO);

          // 2) ZONA: el ultimo 22% del banner visible. De aqui sale el color
          //    predominante. Hace falta porque hay banners que terminan en una
          //    franja blanca dibujada: su borde es blanco y el degradado no se
          //    percibia, aunque el banner sea azul oscuro.
          var cz = recorte(g, muestra, 0.22);
          ctx.clearRect(0, 0, ANCHO, ALTO);
          ctx.drawImage(muestra, cz.sx, cz.sy, cz.sw, cz.sh, 0, 0, ANCHO, 1);
          var zona = medianaFila(ctx.getImageData(0, 0, ANCHO, 1).data, ANCHO, RADIO);

          // 3) Aclarar la zona hacia el fondo de la pagina hasta un minimo de
          //    luminancia. Asi un banner oscuro da un velo suave y nunca
          //    compromete la lectura de lo que va debajo.
          var pap = papel();
          var MIN_LUM = 200;
          var lumPapel = luminancia(pap[0], pap[1], pap[2]);
          for (var i = 0; i < ANCHO; i++) {
            var lz = luminancia(zona[i * 4], zona[i * 4 + 1], zona[i * 4 + 2]);
            if (lz < MIN_LUM && lumPapel > lz) {
              var t = Math.min(1, (MIN_LUM - lz) / (lumPapel - lz));
              for (var ch = 0; ch < 3; ch++) {
                zona[i * 4 + ch] = Math.round(zona[i * 4 + ch] * (1 - t) + pap[ch] * t);
              }
            }
          }

          // 4) Rampa vertical: borde arriba (empalme) -> zona (color). El
          //    desvanecido final no va aqui, lo pone la mascara del CSS.
          var lienzo2 = document.createElement('canvas');
          lienzo2.width = ANCHO; lienzo2.height = ALTO;
          var ctx2 = lienzo2.getContext('2d', { willReadFrequently: true });
          var img2 = ctx2.createImageData(ANCHO, ALTO);
          for (var y = 0; y < ALTO; y++) {
            // La zona se alcanza hacia el 40% de la banda, con entrada suave
            var u = Math.min(1, y / (ALTO * 0.4));
            var k = u * u * (3 - 2 * u);
            for (var x2 = 0; x2 < ANCHO; x2++) {
              var o = (y * ANCHO + x2) * 4, b = x2 * 4;
              for (var ch2 = 0; ch2 < 3; ch2++) {
                img2.data[o + ch2] = Math.round(borde[b + ch2] * (1 - k) + zona[b + ch2] * k);
              }
              img2.data[o + 3] = 255;
            }
          }
          ctx2.putImageData(img2, 0, 0);

          // Color plano de respaldo: mediana del borde (empalma sin costura)
          var med = [0, 0, 0], ordenar = function (a, b) { return a - b; };
          for (var ch3 = 0; ch3 < 3; ch3++) {
            var todos = [];
            for (var q = 0; q < ANCHO; q++) todos.push(borde[q * 4 + ch3]);
            todos.sort(ordenar);
            med[ch3] = todos[todos.length >> 1];
          }
          res.color = 'rgb(' + med[0] + ', ' + med[1] + ', ' + med[2] + ')';
          res.tira = lienzo2.toDataURL('image/png');
          colorCache[clave] = res;
        } catch (e) {
          // Sin permiso CORS el lienzo queda contaminado: nos vale el color del slide
        }
        aplicar(res, slide);
      };
      muestra.onerror = function () { aplicar({ color: respaldo }, slide); };
      muestra.src = img.currentSrc;
    }

    // Las imagenes diferidas llegan tarde; y al cambiar de tamano cambia el recorte
    Array.prototype.forEach.call(root.querySelectorAll('.hero-c__bg'), function (img) {
      if (!img.complete) img.addEventListener('load', pintarSangrado);
    });
    var temporizadorRedim = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(temporizadorRedim);
      temporizadorRedim = window.setTimeout(pintarSangrado, 180);
    });

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (slide, i) {
        var active = i === index;
        // Reiniciar la animacion de entrada en cada cambio
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        // Fuera del flujo del tabulador lo que no se ve
        Array.prototype.forEach.call(slide.querySelectorAll('a, button'), function (el) {
          if (active) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
      // Forzar un reflow para que la animacion vuelva a dispararse
      void slides[index].offsetWidth;
      slides[index].classList.add('is-active');
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      pintarSangrado();
    }

    function goTo(i, restart) {
      var total = slides.length;
      index = ((i % total) + total) % total;
      render();
      if (restart !== false) schedule();
    }

    function schedule() {
      stop();
      if (!delay || reduced || slides.length < 2) return;
      timer = window.setTimeout(function () {
        if (!paused && document.visibilityState !== 'hidden') goTo(index + 1);
        else schedule();
      }, delay);
    }

    function stop() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Pausa mientras el raton esta encima o el foco esta dentro
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) paused = false;
    });

    // Teclado
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
    });

    // Swipe en tactil. Solo cuenta el gesto horizontal, para no secuestrar el scroll.
    var startX = 0, startY = 0, tracking = false;
    var viewport = root.querySelector('[data-hero-viewport]') || root;
    viewport.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
      paused = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      paused = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) goTo(index + (dx < 0 ? 1 : -1));
      else schedule();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stop();
      else schedule();
    });

    root.classList.add('is-ready');
    render();
    schedule();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hero-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
